import pickBy from 'lodash/pickBy'

export default {
  watch: {
    $data: {
      // Коллбэк будет вызываться каждый раз, когда изменяется любое из свойств
      // наблюдаемого объекта (data), независимо от глубины их вложенности
      handler () {
        this.saveState()
      },
      deep: true
    }
  },

  created () {
    this.loadState()
  },

  methods: {
    loadState () {
      const storeState = sessionStorage.getItem(this.saveStateConfig().saveKey)
      if (!storeState) { return }
      const savedState = JSON.parse(storeState)
      Object.keys(savedState).forEach(key => {
        if (this.needToSave(key)) {
          let value = savedState[key]
          if (this.saveStateConfig().onLoad) {
            value = this.saveStateConfig().onLoad(key, value)
          }
          this.$data[key] = value
        }
      })
    },

    saveState () {
      const data = pickBy(this.$data, (value, attribute) => {
        return this.needToSave(attribute)
      })

      sessionStorage.setItem(this.saveStateConfig().saveKey, JSON.stringify(data))
    },

    needToSave (attribute) {
      if (this.saveStateConfig().ignoreProperties &&
        this.saveStateConfig().ignoreProperties.indexOf(attribute) !== -1) {
        return false
      }

      return !this.saveStateConfig().saveProperties || this.saveStateConfig().saveProperties.indexOf(attribute) !== -1
    }
  }
}
